import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { SMALL_GROUP_BENEFITS } from '@/data/content';
import { fadeUp, stagger, viewportOnce } from '@/lib/motion';

export default function SmallGroup() {
  return (
    <section id="small-group" className="relative py-24 sm:py-32 bg-night-surface border-y border-white/5 overflow-hidden" data-testid="small-group-section">
      <span className="absolute top-1/2 -translate-y-1/2 -left-10 font-display text-[26vw] leading-none text-stroke-white opacity-[0.05] select-none pointer-events-none" aria-hidden="true">14+1</span>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={viewportOnce} className="flex items-center gap-4 mb-5">
            <span className="font-display text-3xl sm:text-4xl text-stroke-gold leading-none">08</span>
            <span className="h-px w-12 bg-brand-gold/50" />
            <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-brand-gold font-semibold">Small Group Philosophy</span>
          </motion.div>
          <motion.h2
            variants={fadeUp} custom={1} initial="hidden" whileInView="show" viewport={viewportOnce}
            className="font-display uppercase tracking-tight leading-[0.95] text-4xl sm:text-5xl lg:text-6xl text-white"
          >
            EVERY PLAYER<br />MATTERS.
          </motion.h2>
          <motion.p
            variants={fadeUp} custom={2} initial="hidden" whileInView="show" viewport={viewportOnce}
            className="mt-6 text-base sm:text-lg text-gray-400 leading-relaxed max-w-lg"
          >
            We believe players develop faster when coaches can see them, correct them and challenge them.
          </motion.p>
          <motion.ul
            variants={stagger} initial="hidden" whileInView="show" viewport={viewportOnce}
            className="mt-8 space-y-3"
            data-testid="small-group-benefits"
          >
            {SMALL_GROUP_BENEFITS.map((b, i) => (
              <motion.li key={b} variants={fadeUp} custom={i} className="flex items-center gap-3 text-gray-200">
                <span className="w-6 h-6 rounded-full bg-brand-gold/15 border border-brand-gold/40 flex items-center justify-center shrink-0">
                  <Check size={13} className="text-brand-gold" />
                </span>
                <span className="text-base sm:text-lg font-semibold">{b}</span>
              </motion.li>
            ))}
          </motion.ul>
        </div>

        <motion.div
          variants={fadeUp} initial="hidden" whileInView="show" viewport={viewportOnce}
          className="relative"
          data-testid="small-group-numbers"
        >
          <div className="glass-card rounded-sm p-10 sm:p-14 text-center gold-hairline">
            <div className="font-display leading-none">
              <span className="text-[6rem] sm:text-[8rem] text-transparent bg-clip-text bg-gradient-to-b from-white to-gray-500">14</span>
            </div>
            <div className="mt-2 text-xs sm:text-sm uppercase tracking-[0.3em] text-brand-gold font-bold">Max Outfield Players</div>
            <div className="my-6 flex items-center gap-4 justify-center">
              <span className="h-px w-16 bg-white/15" />
              <span className="font-display text-4xl text-brand-red">+1</span>
              <span className="h-px w-16 bg-white/15" />
            </div>
            <div className="font-display text-2xl sm:text-3xl text-white uppercase tracking-wide">Goalkeeper</div>
            <div className="mt-6 inline-block border border-brand-red/50 bg-brand-red/10 text-brand-red font-display tracking-[0.3em] text-sm px-6 py-2 rounded-full uppercase">
              Per Coach
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
